"use client";

import { Category } from "src/server/zsl/templates/types";
import { usePathname, useSearchParams } from "next/navigation";
import { SecondaryNav } from "@zapier/design-system-beta";
import Link from "next/link";

interface SidebarProps {
  categories: Category[];
  className?: string;
  apps?: {
    name: string;
    slug: string;
  }[];
}

const NAVIGATION_KEYS = {
  category: "category",
  app: "app",
  allTemplates: "all-templates",
} as const;

export const GallerySidebar = ({
  categories = [],
  apps = [],
  className,
}: SidebarProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const activeCategory = searchParams?.get(NAVIGATION_KEYS.category);
  const activeApp = searchParams?.get(NAVIGATION_KEYS.app);

  const defaultSelectedItem =
    activeCategory || activeApp || NAVIGATION_KEYS.allTemplates;

  const defaultExpandedKey = activeCategory
    ? NAVIGATION_KEYS.category
    : activeApp
      ? NAVIGATION_KEYS.app
      : NAVIGATION_KEYS.category;

  return (
    <div className={className}>
      <SecondaryNav
        defaultSelectedItem={defaultSelectedItem}
        defaultExpandedKeys={defaultExpandedKey ? [defaultExpandedKey] : []}
      >
        <SecondaryNav.Title value="Discover" />
        <SecondaryNav.List>
          <SecondaryNav.Item
            key={NAVIGATION_KEYS.allTemplates}
            itemKey={NAVIGATION_KEYS.allTemplates}
            label="All Templates"
            linkProps={{
              href: pathname || "",
              component: Link,
            }}
          />

          {categories.length > 0 && (
            <SecondaryNav.Item
              key={NAVIGATION_KEYS.category}
              itemKey={NAVIGATION_KEYS.category}
              label="Use Cases"
              linkProps={{}}
            >
              <SecondaryNav.List>
                {categories.map((category) => (
                  <SecondaryNav.Item
                    itemKey={category.slug}
                    key={category.slug}
                    label={category.name}
                    linkProps={{
                      href: `?category=${category.slug}`,
                      component: Link,
                    }}
                  />
                ))}
              </SecondaryNav.List>
            </SecondaryNav.Item>
          )}

          {apps.length > 0 && (
            <SecondaryNav.Item
              key={NAVIGATION_KEYS.app}
              itemKey={NAVIGATION_KEYS.app}
              label="Apps"
              linkProps={{}}
            >
              <SecondaryNav.List>
                {apps.map((app) => (
                  <SecondaryNav.Item
                    itemKey={app.slug}
                    key={app.slug}
                    label={app.name}
                    linkProps={{
                      href: `?app=${app.slug}`,
                      component: Link,
                    }}
                  />
                ))}
              </SecondaryNav.List>
            </SecondaryNav.Item>
          )}
        </SecondaryNav.List>
      </SecondaryNav>
    </div>
  );
};
